"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Demo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var client_1 = __importDefault(require("react-dom/client"));
var apollo_jpg_1 = __importDefault(require("./resources/apollo.jpg"));
require("./index.css");
var src_1 = require("../../src");
var Demo = function () {
    var _a = (0, react_1.useState)('light'), theme = _a[0], setTheme = _a[1];
    var switchTheme = function (theme) {
        switch (theme) {
            case 'light':
                setTheme('dark');
                break;
            case 'dark':
                setTheme('light');
                break;
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(src_1.SmartBanner, { src: apollo_jpg_1.default, title: 'MyApp', author: 'lena.codes', description: 'GET - On the Play Store', buttonLink: 'https://lena.codes', buttonText: 'View', onClose: function () { return alert('pressed the close button!'); }, theme: theme }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: 'container' }, { children: [(0, jsx_runtime_1.jsx)("h1", __assign({ style: { margin: '12px' } }, { children: "smartbanner-react demo (light & dark)" })), (0, jsx_runtime_1.jsx)("button", __assign({ type: 'button', onClick: function () { return switchTheme(theme); }, className: 'switch-theme-button' }, { children: "switch theme" }))] }))] }));
};
exports.Demo = Demo;
var root = client_1.default.createRoot((_a = document.querySelector('#demo')) !== null && _a !== void 0 ? _a : document.createElement('div'));
root.render((0, jsx_runtime_1.jsx)(exports.Demo, {}));
